export interface PanelAnchor {
  left: number;
  width: number;
  top: number;
  maxH: number;
}

const GAP = 6;
const EDGE = 10;

export const measurePanelAnchor = (el: HTMLElement | null, desired: number): PanelAnchor | null => {
  if (!el) {
    return null;
  }
  const r = el.getBoundingClientRect();
  const vh = window.innerHeight;
  const spaceBelow = vh - r.bottom;
  const spaceAbove = r.top;
  let top: number;
  let maxH: number;
  if (spaceBelow >= desired || spaceBelow >= spaceAbove) {
    top = r.bottom + GAP;
    maxH = Math.min(desired, vh - top - EDGE);
  } else {
    maxH = Math.min(desired, spaceAbove - GAP - EDGE);
    top = r.top - GAP - maxH;
  }
  top = Math.min(Math.max(EDGE, top), vh - EDGE - 120);
  maxH = Math.max(120, Math.min(maxH, vh - top - EDGE));
  return { left: Math.round(r.left), width: Math.round(r.width), top: Math.round(top), maxH: Math.round(maxH) };
};
